import React, { useState } from "react";
import classNames from "classnames";
import { MdAddCircle } from 'react-icons/md';
import { Row, Col, FormGroup, Label, Badge, TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import getTrackInfo from "../../requests/trackInfo";
import { getTracksByTags } from "../../requests/getTracks";
import SearchTypeahead from "./SearchTypeahead";
import Button from "./Button";
import Input from "./Input";
import Track from "../Track";
import Player from "../Player";
import List from "../../components/List"
import ScrollContainer from "../../components/ScrollContainer";
import { formatDuration } from "../../utils/formatDigits";
import Typeahead from "./Typeahead";

const TrackFinder = props => {
  const { input, className } = props;
  const [activeTab, setActiveTab] = useState('1');
  const [loading, setLoading] = useState(false);
  const [includeTags, setIncludeTags] = useState([]);
  const [excludeTags, setExcludeTags] = useState([]);
  const [advancedSearchResult, setAdvancedSearchResult] = useState();
  const [sortType, setSortType] = useState(Object.keys(props.sortTypes)[0]);
  let searchInput, trackImporter, trackWindow;
  const importTracks = value => {
    if (value.trim()) {
      setLoading(true);
      getTrackInfo(value)
        .then(response => {
          setLoading(false);
          input.onChange([...input.value, ...response.data.tracks])
          trackImporter.value = '';
          if (trackWindow) trackWindow.scroll(0, 1000000);
        })
        .catch(() => {
          setLoading(false);
        })
    }
  }
  const advancedSearch = () => {
    setLoading(true);
    getTracksByTags({ includeTags: includeTags.map(tag => tag.id), excludeTags: excludeTags.map(tag => tag.id), sortType, length: 100, page: 1 })
      .then(response => {
        setAdvancedSearchResult(response.data.tracks);
        setLoading(false);
      })
      .catch(() => setLoading(false))
  }
  const advancedSearchResultFilter = result => {
    return result.filter(item => !input.value || !input.value.map(i => i.id).includes(item.id))
  }
  return (
    <div className={className}>
      <div className="bg-light p-2 mb-3 rounded">
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classNames({ active: activeTab === '1' })}
              onClick={() => { setActiveTab('1'); }}
            >
              جستجوی مستقیم
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classNames({ active: activeTab === '2' })}
              onClick={() => { setActiveTab('2'); }}
            >
              ورود جمعی با شناسه
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classNames({ active: activeTab === '3' })}
              onClick={() => { setActiveTab('3'); }}
            >
              جستجوی پیشرفته
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab} className="bg-white border border-top-0 rounded-bottom p-3">
          <TabPane tabId="1">
            <Row form>
              <Col>
                <FormGroup>
                  <Label htmlFor="search-tracks-input">جستجوی مستقیم آهنگ</Label>
                  <SearchTypeahead
                    id="search-tracks"
                    inputProps={{ id: 'search-tracks-input' }}
                    label="آهنگ"
                    searchType="track"
                    ref={node => { searchInput = node }}
                    input={{
                      value: [],
                      onChange: selected => {
                        input.onChange([...input.value, ...selected])
                        searchInput.getInstance().clear();
                        if (trackWindow) trackWindow.scroll(0, 1000000);
                      }
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="2">
            <Row form>
              <Col className="flex-grow-1">
                <Input
                  dir="ltr"
                  className="rtl-placeholder"
                  label="شناسه یا شناسه‌ها"
                  id="batch-import"
                  placeholder="شناسه‌ها را با علامت , از هم جدا کنید"
                  disabled={loading}
                  ref={node => { trackImporter = node }}
                  input={{
                    onKeyDown: e => {
                      if (e.keyCode === 13) {
                        e.preventDefault();
                        e.stopPropagation();
                        importTracks(e.target.value);
                      }
                    }
                  }}
                />
              </Col>
              <FormGroup className="d-flex">
                <Button
                  loading={loading}
                  className="align-self-end"
                  type="button"
                  onClick={() => importTracks(trackImporter.value)}
                >
                  وارد کن
                </Button>
              </FormGroup>
            </Row>
          </TabPane>
          <TabPane tabId="3">
            <Row form>
              <Col xs="12" md="10">
                <Row>
                  <Col xs="12">
                    <FormGroup>
                      <Label htmlFor="track-finder-include-tags-input">جستجو در محتوا با تگ‌های</Label>
                      <Typeahead
                        id="track-finder-include-tags"
                        inputProps={{ id: 'track-finder-include-tags' }}
                        options={props.tags.filter(tag => !includeTags.map(t => t.id).includes(tag.id))}
                        selected={includeTags}
                        placeholder="جستجو و انتخاب تگ"
                        emptyLabel="تگی پیدا نشد"
                        multiple
                        paginationText="نمایش موارد بیشتر"
                        labelKey={option =>
                          `${props.tagTypes[option.type]}-${option.value}${
                          option.contentType ? '(' : ''
                          }${
                          props.tagContentTypes[option.contentType || 'no']
                          }${option.contentType ? ')' : ''}`
                        }
                        onChange={tags => {
                          setIncludeTags(tags);
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col xs="12">
                    <FormGroup>
                      <Label htmlFor="track-finder-exclude-tags-input">به جز‌ تگ‌های</Label>
                      <Typeahead
                        id="track-finder-exclude-tags"
                        inputProps={{ id: 'track-finder-exclude-tags' }}
                        options={props.tags}
                        selected={excludeTags}
                        placeholder="جستجو و انتخاب تگ"
                        emptyLabel="تگی پیدا نشد"
                        multiple
                        paginationText="نمایش موارد بیشتر"
                        labelKey={option =>
                          `${props.tagTypes[option.type]}-${option.value}${
                          option.contentType ? '(' : ''
                          }${
                          props.tagContentTypes[option.contentType || 'no']
                          }${option.contentType ? ')' : ''}`
                        }
                        onChange={tags => setExcludeTags(tags)}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
              <Col xs="12" md="2">
                <FormGroup>
                  <Label>نمایش بر اساس</Label>
                  <Input
                    input={{
                      type: "select",
                      onChange: e => setSortType(e.target.value)
                    }}
                    options={Object.keys(props.sortTypes).map(key => (
                      <option value={key} key={key}>{props.sortTypes[key]}</option>
                    ))}
                  />
                </FormGroup>
                <FormGroup>
                  <Label className="fade">Search</Label>
                  <Button
                    block
                    loading={loading}
                    type="button"
                    onClick={() => advancedSearch()}
                  >
                    جستجوی آهنگ
                  </Button>
                </FormGroup>
              </Col>
            </Row>
          </TabPane>
        </TabContent>
      </div>
      <Row>
        <Col>
          <div className="form-group d-flex align-items-center">
            <span>آهنگ‌های کانال</span>
            {input.value && <Badge className="mr-auto">
              {formatDuration(input.value.reduce((acc, current) => acc + (current.durationMin * 60 + current.durationSec), 0))}
            </Badge>
            }
          </div>
          <ScrollContainer ref={node => { trackWindow = node }}>
            <List
              sortable
              axis="y"
              lockAxis="y"
              lockToContainerEdges
              useDragHandle
              parentClassName="list-unstyled"
              render={track => (
                <Track
                  data={track}
                  actions={<><Player src={track.oggPath} /></>}
                />
              )}
              items={input.value || []}
              remove={({ id }) => input.onChange(input.value.filter(trck => trck.id !== id))}
              sort={data => input.onChange(data)}
              showOnHover
            />
          </ScrollContainer>
        </Col>
        {advancedSearchResult &&
          <Col>
            <div className="form-group d-flex align-items-center">
              <span>نتایج جستجو</span>
              <Badge className="mr-auto" color="light">
                {formatDuration(advancedSearchResultFilter(advancedSearchResult).reduce((acc, current) => acc + (current.durationMin * 60 + current.durationSec), 0))}
              </Badge>
            </div>
            <ScrollContainer>
              <List
                parentClassName="list-unstyled"
                render={track => (
                  <Track
                    data={track}
                    actions={
                      <div className="d-flex align-items-center">
                        <Player src={track.oggPath} />
                        <Button
                          color="link"
                          className="has-icon text-primary"
                          onClick={() => {
                            input.onChange([...input.value, track]);
                            if (trackWindow) trackWindow.scroll(0, 1000000);
                          }}
                        >
                          <MdAddCircle />
                        </Button>
                      </div>
                    }
                  />
                )}
                items={advancedSearchResultFilter(advancedSearchResult)}
                sort={data => input.onChange(data)}
              />
            </ScrollContainer>
          </Col>
        }
      </Row>
    </div>
  )
}

export default TrackFinder;